<template>
  <v-card flat>
    <v-card-text>
      <v-layout row style="margin-top: -20px;">

        <v-flex xs3 sm3 md3>
          <h2 class = "title error--text text--darken-4">{{this.currentUser.name}}</h2>
          <h4 class = "font-weight-light error--text text--darken-4">{{this.currentUser.GST_number}}</h4>
        </v-flex>

        <v-flex xs1 sm1 md1>
        </v-flex>

        <v-flex xs3 sm3 md3>
          <v-text-field prefix="#" label="Invoice Number" :readonly="isSummary" placeholder="Invoice Number"  @change="duplicateCheckInvoiceId()" v-model="invoiceId"></v-text-field>
          <h3 class = "error--text text--darken-4">{{duplicateError}}</h3>
        </v-flex>

        <h3 class = "error--text text--darken-4" v-if="!((new Date(invoiceDate).getTime() >= finYear.start) && (new Date(invoiceDate).getTime() <= finYear.end))">This invoice is not in current financial year.</h3>
        
        <v-flex xs1 sm1 md1>
        </v-flex>

        <!-- <v-flex xs2 v-if="!isSummary">
              <v-text-field
              v-model="dateFormatted"
              @change="formatDate()"
              label="Enter Date Manually"
              hint="MM/DD/YYYY format"
              persistent-hint
            ></v-text-field>
        </v-flex> -->

        <v-flex xs3 sm3 md3>
          <v-menu
            :close-on-content-click="false"
            v-model="datepicker"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
          >
            <v-text-field
              slot="activator"
              v-model="invoiceDate"
              label="Date"
              prepend-icon="event"
              readonly
            ></v-text-field>
            <v-date-picker v-model="invoiceDate" :readonly="isSummary" @input="datepicker = false"></v-date-picker>
          </v-menu>
        </v-flex>

        <v-flex xs1 sm1 md1>
        </v-flex>

        <v-flex xs2 sm2 md2>
          <v-text-field
            prefix="#"
            label="Alert (in Days)"
            :readonly="isSummary"
            v-model="alertDuration"
          ></v-text-field>
        </v-flex>

      </v-layout>
    </v-card-text>

    <v-data-table :headers="getHeaders" :items="items" hide-actions class="elevation-1">
      <template slot="items" slot-scope="props">
        <td class="text-xs-left">{{ props.item.productName }}</td>
        <!-- <td class="text-xs-left">{{ props.item.HSN_code }}</td>
        <td>{{ props.item.taxableGST_rate }}</td> -->
        <td>{{ props.item.rate }}</td>
        <td>{{ props.item.unit }}</td>
        <td>{{ props.item.quantity }}</td>
        <td>{{ props.item.basicPrice }}</td>
         <td v-if="gstInvoice">{{ props.item.GSTValue }}</td>
        <td>{{ props.item.tradeDiscount }}</td>
        <td>{{ props.item.totlePrice }}</td>
        <td v-if="gstInvoice">{{ props.item.CGST_val}} ₹ ({{props.item.CGST}} %)</td>
        <td v-if="gstInvoice">{{ props.item.SGST_val}} ₹ ({{props.item.SGST}} %)</td>
        <td v-if="gstInvoice">{{ props.item.IGST_val}} ₹ ({{props.item.IGST}} %)</td>
        <td v-if="!isSummary" class="justify-center layout px-0">
          <v-btn icon class="mx-0" @click="editItem(props.item,false)">
            <v-icon color="teal">edit</v-icon>
          </v-btn>
          <v-btn icon class="mx-0" @click="deleteItem(props.item)">
            <v-icon color="pink">delete</v-icon>
          </v-btn>
        </td>
      </template>
      <template slot="no-data">No Items</template>
    </v-data-table>
    <v-card-actions v-if="!isSummary">
      <!-- <v-btn flat @click="resetForm">Reset</v-btn> -->
      <v-dialog v-model="dialog" persistent max-width="1200px">
        <v-btn flat slot="activator" class="primary white--text">
          <v-icon left dark>add</v-icon>
          New Item
        </v-btn>
        <add-item
          :editedItem="editedItem"
          :buyerId="buyerId"
          :allItems="items"
          :isEditItems="isEditItems"
          @closeAddItem="close"
          :gstInvoice="gstInvoice"
          @saveAddItem="save"
          @editItem="editItem"
          @deleteItem="deleteItem"
        />
      </v-dialog>
      <v-spacer></v-spacer>
      <v-btn
          v-if="selectedFirm && transactionType"
          :disabled="!formIsValid"
          flat
          class="primary white--text"
          @click.native="$emit('next')"
          >Next and confirm
        <v-icon>arrow_right_alt</v-icon>
      </v-btn>
    </v-card-actions>
    
    <!-- <v-card-actions v-if="!isSummary">
        <v-spacer/>
        <v-btn
          v-if="selectedFirm && transactionType"
          :disabled="!formIsValid"
          flat
          class="primary white--text"
          @click.native="$emit('next')"
          >Next and confirm
        <v-icon>arrow_right_alt</v-icon>
      </v-btn>  
    </v-card-actions> -->


      <v-card-actions v-if="isSummary">
        <v-btn flat class="grey white--text" @click.native="$emit('back')">Back</v-btn>
        <v-btn flat class="error white--text" @click="print()">E-way Bill</v-btn>
        <v-btn flat class="warning white--text" @click="basicInvoicePrint()">Basic Print</v-btn>
        <v-spacer></v-spacer>
        <v-btn flat @click.native="saveAndPrint()" class="info white--text">Save & Print</v-btn>
        <v-btn flat @click.native="saveInvoice()" class="primary white--text">Save Invoice</v-btn>
      </v-card-actions>

    <v-dialog v-model="transactionDialog" persistent max-width="500px">
      <v-card>
        <v-card-title class="primary white--text">
          <span class="headline">Payment Details
            <!-- {{transactionType}} -->
          </span>
          <v-spacer/>
          <v-btn icon dark @click.native="transactionDialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>          
                <!-- <v-text-field
                  readonly
                  :value="(Number.parseFloat(totalAmount) - (Number.parseFloat(GST_Val_total.SGST_val) + Number.parseFloat(GST_Val_total.CGST_val) + Number.parseFloat(GST_Val_total.IGST_val)))"
                  type="number"
                  label="Taxable Amount (in ₹)"
                ></v-text-field>
                <v-text-field
                  readonly
                  :value="Number.parseFloat(GST_Val_total.SGST_val) + Number.parseFloat(GST_Val_total.CGST_val) + Number.parseFloat(GST_Val_total.IGST_val)"
                  type="number"
                  label="GST Amount (in ₹)"
                ></v-text-field> -->
                <v-text-field
                  type="number"
                  label="Total Amount (in ₹)"
                  readonly
                  :value="totalAmount"
                  prefix
                ></v-text-field>
                <!-- <v-text-field 
                  type="number" 
                  label="Discount (in ₹)" 
                  v-model="discountAmount">
                </v-text-field>
                <v-text-field 
                  type="number" 
                  label="Round Off" 
                  v-model="roundOff">
                </v-text-field> -->
                <v-select
                  dense
                  :readonly="isSummary"
                  :items="[{
                            text: 'Cash',
                            value: 'Cash'
                          }, {
                            text: 'Bank Account',
                            value: 'Bank Account'
                          }, {
                            text: 'Cash & Bank Account',
                            value: 'CashAndBank Account'
                          }]"
                  label="Select Payment Type"
                  @change="resetAmounts()"
                  v-model="paymentType"
                ></v-select>
          
                <v-select
                  dense
                  :items="banksByFirms"
                  v-if="['Bank Account','CashAndBank Account'].includes(paymentType)"
                  label="Select Bank"
                  v-model="selectedBank"
                  :readonly="isSummary"
                  :disabled="paymentType == 'Cash' || paymentType == ''"
                ></v-select>
            
                <v-select
                  dense
                  :disabled="paymentType == 'Cash' || paymentType == ''"
                  v-if="['Bank Account','CashAndBank Account'].includes(paymentType)"
                  :readonly="isSummary"
                  :items="[{
                      text: 'Cheque',
                      value: 'Cheque'
                    }, {
                      text: 'NEFT',
                      value: 'NEFT'
                    }, {
                      text: 'RTGS',
                      value: 'RTGS'
                    }, {
                      text: 'IMPS',
                      value: 'IMPS'
                    }]"
                  label="Select Transfer type"
                  v-model="transferType"
                  @input="transferTypeDialog = true"
                ></v-select>
             
                <!-- <v-text-field
                  type="number"
                  label="Available Balance (in ₹)"
                  readonly
                  :value="availableBalance"
                ></v-text-field> -->
                
                <v-text-field
                  v-if="['Cash', 'CashAndBank Account'].includes(paymentType)"
                  :readonly="isSummary"
                  v-model="amountFromCash"
                  type="number"
                  :disabled="amountFromCashDisabled"
                  label="Amount from Cash"
                ></v-text-field>
             
                <v-text-field
                  v-if="['Bank Account','CashAndBank Account'].includes(paymentType)"
                  :readonly="isSummary"
                  v-model="amountFromBank"
                  type="number"
                  :disabled="amountFromBankDisabled"
                  label="Amount from Bank"
                ></v-text-field>
              
                <v-text-field
                  v-if="remainingAmount > 0"
                  type="number"
                  label="Remaining Amount (in ₹)"
                  readonly
                  v-model="remainingAmount"
                  prefix
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <!-- <v-btn color="blue darken-1" flat @click.native="transactionDialog = false">Confirm</v-btn> -->
          <v-btn color="blue darken-1" flat  :disabled="!paymentType" @click.native="transactionDialog = false">Confirm</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="transferTypeDialog" max-width="500px">
      <v-card>
        <v-card-title class="primary white--text">
          <span class="headline">
            Transfer Information
            <b>{{transferType}}</b>
          </span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 sm6 md6>
                <v-text-field
                  type="number"
                  v-model="transferDetails.accountNumber"
                  label="A/C Number"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-text-field
                  type="text"
                  v-model="transferDetails.accountHolderName"
                  label="A/C Holder Name"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-text-field type="text" v-model="transferDetails.bankName" label="Bank Name"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-text-field type="text" v-model="transferDetails.IFSCcode" label="IFSC Code"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-text-field type="text" v-model="transferDetails.remark" label="Remark"></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click.native="transferTypeDialog = false">Ok</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-card-text>
      <v-layout dense flat row wrap>
        <v-flex xs12 s12 md8>
          <v-expansion-panel class="invoiceExpansion">
            <v-expansion-panel-content :value="expansionVal">
              <template v-slot:header>
                  <v-card-title>
                    <h3 class="title font-weight-light primary white--text">BASIC DETAILS</h3>
                  </v-card-title>
              </template>
              <v-card>
                <v-card-text>
                  <v-layout row wrap>
                    <v-flex xs4>
                      <v-text-field label="Total Item" readonly :value="totalItems"></v-text-field>
                    </v-flex>
                    <v-flex xs4>
                      <v-select
                        dense
                        :items="firmsByBrand"
                        label="Select Firm"
                        :readonly="isSummary"
                        v-model="selectedFirm"
                      ></v-select>
                    </v-flex>
                    <v-flex xs4>
                      <v-select
                        dense
                        :readonly="isSummary"
                        :items="[{
                          text: 'Due',
                          value: 'Debit'
                        }, {
                          text: 'Partial Paid',
                          value: 'Partial Paid'
                        }, {
                          text: 'Full Paid',
                          value: 'Credit'
                        }]"
                        label="Select Transaction type"
                        @change="resetAmounts()"
                        :disabled="!items.length"
                        v-model="transactionType"
                      ></v-select>
                    </v-flex>

                    <v-flex xs4>
                      <v-text-field 
                        type="number" 
                        label="Labour Charge" 
                        v-model="labourAmount">
                      </v-text-field>
                    </v-flex>
                  
                    <v-flex xs4>
                      <v-text-field 
                        type="number" 
                        label="Discount (in ₹)" 
                        v-model="discountAmount">
                      </v-text-field>
                    </v-flex>

                    <v-flex xs4>
                      <v-text-field 
                        type="number" 
                        label="Round Off (in ₹)" 
                        v-model="roundOffAmount">
                      </v-text-field>
                    </v-flex>

                    <!-- <v-flex xs4>
                      <v-select
                        dense
                        :items="godawnByBrand"
                        label="Via Godawn"
                        :readonly="isSummary"
                        v-model="godawnBy"
                      ></v-select>
                    </v-flex> -->
                  
                    <v-flex xs4>
                      <v-select
                        dense
                        :items="staffByBrand"
                        label="Sold By"
                        :readonly="isSummary"
                        v-model="soldBy"
                      ></v-select>
                    </v-flex>


                      <v-flex xs4>
                      <v-text-field 
                        type="Number"
                        label="Brokerage Rate (in %)" 
                        v-model="brokerageRate">
                      </v-text-field>
                    </v-flex>

                      <v-flex xs4>
                       <v-text-field 
                        type="number" 
                        label="Brokerage Amount (in ₹)"
                        disabled
                        :value="Number.parseFloat(((Number.parseFloat(totalAmount)  - (Number.parseFloat(discountAmount))) * brokerageRate)/100).toFixed(2)"  
                        >
                      </v-text-field>
                    </v-flex>


                    <v-flex xs4>
                        <v-select
                        dense
                        :items="gState"
                        label="Place of Supply"
                        item-text="state"
                        :readonly="isSummary"
                        v-model="placeOfSupply"
                      ></v-select>
                    </v-flex>

                     <v-flex xs8>
                        <v-textarea
                        box  
                        label="Remark"
                        :readonly="isSummary"
                        v-model="remark">
                      </v-textarea>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-flex>
        <v-flex xs12 s12 md4>
          <v-expansion-panel class="invoiceExpansion">
            <v-expansion-panel-content :value="expansionVal">
              <template v-slot:header>
                <div>
                  <v-card-title>
                    <h3 class="title font-weight-light primary white--text">INVOICE DETAILS</h3>
                  </v-card-title>
                </div>
              </template>
              <v-card>
                <v-card-text>
                   <v-layout row wrap>
                    <v-flex xs12 sm6 md6 style="margin-top : -5px;">
                      <h3 class="primary--text">Taxable Amount</h3>
                    </v-flex>
                    <v-flex xs12 sm6 md6 style="display:inline-flex;">  
                      <v-text-field
                        style="margin-top : -20px;"
                        readonly
                        :value="((Number.parseFloat(totalAmount) - Number.parseFloat(roundOffAmount)) - (Number.parseFloat(GST_Val_total.SGST_val) + Number.parseFloat(GST_Val_total.CGST_val) + Number.parseFloat(GST_Val_total.IGST_val))).toFixed(2)"
                        type="number"
                      ></v-text-field>
                    </v-flex>  
                    <v-flex xs12 sm6 md6 style="margin-top : -5px;" v-if="gstInvoice">
                      <h3 class="primary--text">CGST Amount</h3>
                    </v-flex>
                    <v-flex xs12 s6 md6 style="display:inline-flex;" v-if="gstInvoice">
                      <v-text-field
                        style="margin-top : -20px;"
                        readonly
                        :value="GST_Val_total.CGST_val.toFixed(2)"
                        type="number"
                      ></v-text-field>
                    </v-flex>  
                    <v-flex xs12 sm6 md6 style="margin-top : -5px;" v-if="gstInvoice">
                      <h3 class="primary--text"> SGST Amount </h3>
                    </v-flex>
                    <v-flex xs12 s6 md6 style="display:inline-flex;" v-if="gstInvoice">
                      <v-text-field
                        style="margin-top : -20px;"
                        readonly
                        :value="GST_Val_total.SGST_val.toFixed(2)"
                        type="number"
                      ></v-text-field>
                    </v-flex>    
                    <v-flex xs12 sm6 md6 style="margin-top : -5px;" v-if="gstInvoice">
                      <h3 class="primary--text"> IGST Amount </h3>
                    </v-flex>
                    <v-flex xs12 s6 md6 style="display:inline-flex;" v-if="gstInvoice">  
                      <v-text-field
                        style="margin-top : -20px;"
                        readonly
                        :value="GST_Val_total.IGST_val.toFixed(2)"
                        type="number"
                      ></v-text-field>
                    </v-flex>

                    <v-flex xs12 sm6 md6 style="margin-top : -5px;">
                     <h3 class="primary--text"> Labour Charge: </h3>
                    </v-flex>
                    <v-flex xs12 s6 md6 style="display:inline-flex;"> 
                      <v-text-field
                        readonly
                        style="margin-top : -20px;"
                        type="number" 
                        v-model="labourAmount">
                      </v-text-field>
                    </v-flex>

                    <v-flex xs12 sm6 md6 style="margin-top : -5px;">
                     <h3 class="primary--text"> Discount </h3>
                    </v-flex>
                    <v-flex xs12 s6 md6 style="display:inline-flex;"> 
                      <v-text-field
                        readonly
                        style="margin-top : -20px;"
                        type="number" 
                        v-model="discountAmount">
                      </v-text-field>
                    </v-flex>
                      <v-flex xs12 sm6 md6 style="margin-top : -5px;">
                     <h3 class="primary--text"> Round Off </h3>
                    </v-flex>
                    <v-flex xs12 s6 md6 style="display:inline-flex;"> 
                      <v-text-field
                        readonly
                        style="margin-top : -20px;"
                        type="number" 
                        v-model="roundOffAmount">
                      </v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md6 style="margin-top : -5px;">
                     <h3 class="primary--text"> Invoice Amount </h3> 
                    </v-flex>
                    <v-flex xs12 s6 md6 style="display:inline-flex;">   
                      <v-text-field
                        style="margin-top : -20px;"
                        type="number"
                        readonly
                        :value="((Number.parseFloat(totalAmount) + Number.parseFloat(labourAmount || 0 | amount))  - (Number.parseFloat(discountAmount || 0 | amount))).toFixed(2)" 
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-flex>
      </v-layout>
      

      <v-layout row wrap>
        <v-flex xs12 s12 md12>
          <v-expansion-panel class="invoiceExpansion">
            <v-expansion-panel-content>
              <template v-slot:header>
                <div>
                  <v-card-title>
                    <h3 class="title font-weight-light primary white--text">EXTRA DETAILS</h3>
                  </v-card-title>
                </div>
              </template>
              <v-card>
                <v-card-text>
                  <v-layout row wrap>
                    <v-flex xs12 s12 md6>
                             <v-text-field
                        readonly
                        :value="GST_Percentage_total.GST_0"
                        type="number"
                        v-if="gstInvoice"
                        label="Total GST(0%)"
                      ></v-text-field>
                      <br />
                      <v-text-field
                        readonly
                        v-if="gstInvoice"
                        :value="GST_Percentage_total.GST_5"
                        type="number"
                        label="Total GST(5%)"
                      ></v-text-field>
                      <br />
                      <v-text-field
                        readonly
                        v-if="gstInvoice"
                        :value="GST_Percentage_total.GST_12"
                        type="number"
                        label="Total GST(12%)"
                      ></v-text-field>
                      <br />
                      <v-text-field
                        readonly
                        v-if="gstInvoice"
                        :value="GST_Percentage_total.GST_18"
                        type="number"
                        label="Total GST(18%)"
                      ></v-text-field>
                      <br />
                      <v-text-field
                        v-if="gstInvoice"
                        readonly
                        :value="GST_Percentage_total.GST_28"
                        type="number"
                        label="Total GST(28%)"
                      ></v-text-field>
                      <br />
                      <v-btn
                        flat
                        color="primary"
                        @click.native="transactionDialog = true"
                      >Transaction Details</v-btn>
                    </v-flex>
                    <v-flex xs12 s12 md6>
                      <v-select
                        dense
                        :readonly="isSummary"
                        :items="[{
                            text: 'Cash',
                            value: 'Cash'
                          }, {
                            text: 'Bank Account',
                            value: 'Bank Account'
                          }, {
                            text: 'Cash & Bank Account',
                            value: 'CashAndBank Account'
                          }]"
                        label="Select Payment Type"
                        @change="resetAmounts()"
                        v-model="paymentType"
                      ></v-select>
                      <br />

                      <v-text-field
                        :readonly="isSummary"
                        v-model="amountFromCash"
                        type="number"
                        :disabled="amountFromCashDisabled"
                        label="Amount from Cash"
                      ></v-text-field>
                      <br />
                      <v-text-field
                        :readonly="isSummary"
                        v-model="amountFromBank"
                        type="number"
                        :disabled="amountFromBankDisabled"
                        label="Amount from Bank"
                      ></v-text-field>
                      <br />

                      <v-text-field
                        type="number"
                        label="Paid Amount (in ₹)"
                        readonly
                        v-model="paidAmount"
                        prefix
                      ></v-text-field>
                      <br />
                      <v-text-field
                        type="number"
                        label="Remaining Amount (in ₹)"
                        readonly
                        v-model="remainingAmount"
                        prefix
                      ></v-text-field>
                      <br />
                      <v-select
                        dense
                        :readonly="isSummary"
                        :items="[{
                            text: 'Due',
                            value: 'Debit'
                          }, {
                            text: 'Partial Paid',
                            value: 'Partial Paid'
                          }, {
                            text: 'Full Paid',
                            value: 'Credit'
                          }]"
                        label="Select Transaction type"
                        @change="resetAmounts()"
                        :disabled="!items.length"
                        v-model="transactionType"
                      ></v-select>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-flex>
      </v-layout>

      <!-- <v-layout row>
        <v-flex xs1>
          <v-text-field label="Total Item" readonly :value="totalItems"></v-text-field>
        </v-flex>
        <v-flex xs3>
          <v-select
            dense
            :readonly="isSummary"
            :items="[{
              text: 'Cash',
              value: 'Cash'
            }, {
              text: 'Bank Account',
              value: 'Bank Account'
            }, {
              text: 'Cash & Bank Account',
              value: 'CashAndBank Account'
            }]"
            label="Select Payment Type"
            @change="resetAmounts()"
            v-model="paymentType"
          ></v-select>
        </v-flex>
        <v-flex xs3>
          <v-select
            dense
            :items="firmsByBrand"
            label="Select Firm"
            :readonly="isSummary"
            v-model="selectedFirm"
          ></v-select>
        </v-flex>

        <v-flex xs3>
          <v-select
            dense
            :items="banksByFirms"
            label="Select Bank"
            v-model="selectedBank"
            :readonly="isSummary"
            :disabled="paymentType == 'Cash' || paymentType == ''"
          ></v-select>
        </v-flex>

        <v-flex xs2>
          <v-text-field
            type="number"
            label="Available Balance (in ₹)"
            readonly
            :value="availableBalance"
          ></v-text-field>
        </v-flex>
        <v-spacer />
      </v-layout>
      <v-layout row>
        <v-flex xs3>
          <v-text-field
            readonly
            :value="Number.parseFloat(GST_Val_total.SGST_val) + Number.parseFloat(GST_Val_total.CGST_val) + Number.parseFloat(GST_Val_total.IGST_val)"
            type="number"
            label="Total GST"
          ></v-text-field>
        </v-flex>
        <v-flex xs3>
          <v-text-field readonly :value="GST_Val_total.SGST_val" type="number" label="Total SGST"></v-text-field>
        </v-flex>
        <v-flex xs3>
          <v-text-field readonly :value="GST_Val_total.CGST_val" type="number" label="Total CGST"></v-text-field>
        </v-flex>
        <v-flex xs3>
          <v-text-field readonly :value="GST_Val_total.IGST_val" type="number" label="Total IGST"></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout row>
        <v-flex xs2>
          <v-text-field
            readonly
            :value="GST_Percentage_total.GST_0"
            type="number"
            label="Total GST(0%)"
          ></v-text-field>
        </v-flex>
        <v-flex xs2>
          <v-text-field
            readonly
            :value="GST_Percentage_total.GST_5"
            type="number"
            label="Total GST(5%)"
          ></v-text-field>
        </v-flex>
        <v-flex xs2>
          <v-text-field
            readonly
            :value="GST_Percentage_total.GST_12"
            type="number"
            label="Total GST(12%)"
          ></v-text-field>
        </v-flex>
        <v-flex xs2>
          <v-text-field
            readonly
            :value="GST_Percentage_total.GST_18"
            type="number"
            label="Total GST(18%)"
          ></v-text-field>
        </v-flex>
        <v-flex xs2>
          <v-text-field
            readonly
            :value="GST_Percentage_total.GST_28"
            type="number"
            label="Total GST(28%)"
          ></v-text-field>
        </v-flex>
        <v-flex xs2>
          <v-text-field
            readonly
            :value="(Number.parseFloat(totalAmount) - (Number.parseFloat(GST_Val_total.SGST_val) + Number.parseFloat(GST_Val_total.CGST_val) + Number.parseFloat(GST_Val_total.IGST_val)))"
            type="number"
            label="Basic Amount (in ₹)"
          ></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout row>
        <v-flex xs6>
          <v-select
            dense
            :readonly="isSummary"
            :items="[{
              text: 'Debit',
              value: 'Debit'
            }, {
              text: 'Partial Paid',
              value: 'Partial Paid'
            }, {
              text: 'Credit',
              value: 'Credit'
            }]"
            label="Select Transaction type"
            @change="resetAmounts()"
            v-model="transactionType"
          ></v-select>
        </v-flex>
        <v-flex xs6>
          <v-text-field type="number" label="Discount (in ₹)" v-model="discountAmount"></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout row>
        <v-flex xs6>
          <v-text-field
            :readonly="isSummary"
            v-model="amountFromCash"
            type="number"
            :disabled="amountFromCashDisabled"
            label="Amount from Cash"
          ></v-text-field>
        </v-flex>
        <v-flex xs6>
          <v-text-field
            :readonly="isSummary"
            v-model="amountFromBank"
            type="number"
            :disabled="amountFromBankDisabled"
            label="Amount from Bank"
          ></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout row>
        <v-flex xs4>
          <v-text-field
            type="number"
            label="Paid Amount (in ₹)"
            readonly
            v-model="paidAmount"
            prefix
          ></v-text-field>
        </v-flex>
        <v-flex xs4>
          <v-text-field
            type="number"
            label="Remaining Amount (in ₹)"
            readonly
            v-model="remainingAmount"
            prefix
          ></v-text-field>
        </v-flex>
        <v-flex xs4>
          <v-text-field
            type="number"
            label="Total Amount (in ₹)"
            readonly
            :value="totalAmount"
            prefix
          ></v-text-field>
        </v-flex>
      </v-layout>-->
    </v-card-text>
    
    <v-card-actions>
      <v-dialog
        v-model="printDialog"
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
        scrollable
        persistent
      >
        <v-card tile style="height: fit-content;">
          <v-toolbar card dark color="primary">
            <v-toolbar-title>Print an E-Way Bill</v-toolbar-title>
            <v-spacer/>
            <v-btn icon dark @click.native="printDialog = false">
              <v-icon>close</v-icon>
            </v-btn>
          </v-toolbar>
          <print-invoice
            :invoiceData="invoiceDraft"
            :bank="bankById(selectedBank)"
            :firm="firmById(selectedFirm)"
            :seller="sellerById(selectedBuyer)"
            :buyer="buyerById(selectedBuyer)"
            :termsAndConditions="getTermsAndConditions()"
            :gstTotal="GST_Val_total"
          />
          <div style="flex: 1 1 auto;"></div>
        </v-card>
      </v-dialog>
    </v-card-actions>
  </v-card>
</template>


<script>
import { createNamespacedHelpers } from "vuex";
import AddItem from "./AddItem";
import PrintInvoice from "./PrintInvoice";
import { convertToBasicInvoice,convertToBasicInvoiceWithoutGST } from "../../../utils/pdfmake";
import { getGSTPercentageTotal } from "../../../utils/";
const mapGlobalGetters = createNamespacedHelpers("Global")["mapGetters"];
const mapBuyerGetters = createNamespacedHelpers("Buyer")["mapGetters"];

export default {
  components: {
    AddItem,
    PrintInvoice
  },
  props: {
    isSummary: {
      type: Boolean,
      default: false
    },
    invoiceData: {
      type: Object,
      default: function() {
        return {
          items: [],
          rate: 2,
          totalAmount: 0,
          buyerId: null
        };
      }
    },
    buyerId: String,
    mode : Number
  },
  data() {
    return {
      formIsValid: true,
      dialog: false,
      gstInvoice : false,
      isEditItems : false,
      isUserBuyer : null,
      duplicateError : null,
      items: this.invoiceData.items || [],
      totalTradeDiscount : this.invoiceData.totalTradeDiscount || 0,
      editedIndex: -1,
      editedItem: {
        productName: "",
        productId: "",
        HSN_code: "",
        taxableGST_rate: 0,
        rate: 0,
        unit: "",
        quantity: 0,
        basicPrice: 0,
        GSTValue: 0,
        totlePrice: 0,
        tradeDiscount : 0,
        expiryDate : new Date(new Date().setFullYear(new Date().getFullYear()+100)).toISOString().substr(0, 10),
        manufacturingDate : new Date(new Date().setFullYear(new Date().getFullYear()+100)).toISOString().substr(0, 10),
        batchNumber : 'DEFAULT'
      },
      defaultItem: {
        productName: "",
        productId: "",
        HSN_code: "",
        taxableGST_rate: 0,
        rate: 0,
        unit: "",
        quantity: 0,
        basicPrice: 0,
        GSTValue: 0,
        totlePrice: 0,
        tradeDiscount : 0,
        expiryDate : new Date(new Date().setFullYear(new Date().getFullYear()+100)).toISOString().substr(0, 10),
        manufacturingDate : new Date(new Date().setFullYear(new Date().getFullYear()+100)).toISOString().substr(0, 10),
        batchNumber : 'DEFAULT'
      },
      amountFromCash: this.invoiceData.amountFromCash || 0,
      amountFromBank: this.invoiceData.amountFromBank || 0,
      alertDuration: this.invoiceData.duration || 0,
      paymentType: this.invoiceData.paymentType || "",
      selectedFirm: this.invoiceData.firm || "",
      selectedBank: this.invoiceData.bank || "",
      soldBy : this.invoiceData.soldBy || '',
      brokerageRate : this.invoiceData.brokerageRate || 0,
      // godawnBy : this.invoiceData.godawnBy || '',
      placeOfSupply : this.invoiceData.placeOfSupply || '',
      invoiceDate: this.invoiceData.date
        ? new Date(this.invoiceData.date).toISOString().substr(0, 10)
        : new Date().toISOString().substr(0, 10),
      dateFormatted: this.invoiceData.date
        ? new Date(this.invoiceData.date).toISOString().substr(0, 10)
        : new Date().toISOString().substr(0, 10),
      datepicker: false,
      totalAmount: this.invoiceData.totalAmount || 0,
      paidAmount: this.invoiceData.paidAmount || 0,
      remainingAmount: this.invoiceData.remainingAmount || 0,
      labourAmount: this.invoiceData.labourAmount || 0,
      discountAmount: this.invoiceData.discountAmount || 0,
      roundOffAmount: this.invoiceData.roundOffAmount || 0,
      invoiceDraft: {},
      transferType: ["Cash", ""].includes(this.invoiceData.paymentType)
        ? "0"
        : this.invoiceData.transferType,
      transferTypeDialog: false,
      availableBalance: 0,
      firms: [],
      staffs: [],
      // godawns: [],
      banks: [],
      transactionType: this.invoiceData.transactionType || "",
      amountFromCashDisabled: true,
      amountFromBankDisabled: true,
      status: this.invoiceData.status,
      gstType: this.invoiceData.gstType,
      currentUser: {},
      remark : null,
      invoiceId: this.invoiceData.invoiceId || '',
      GST_Val_total: {
        CGST_val: 0,
        SGST_val: 0,
        IGST_val: 0
      },
      GST_Percentage_total: {
        GST_0: 0,
        GST_5: 0,
        GST_12: 0,
        GST_18: 0,
        GST_28: 0
      },
      roundOff : 2,
      printDialog: false,
      transactionDialog: false,
      expansionVal : false,
      transferDetails: {
        accountNumber:
          (this.invoiceData.transferDetails &&
            this.invoiceData.transferDetails.accountNumber) ||
          "",
        accountHolderName:
          (this.invoiceData.transferDetails &&
            this.invoiceData.transferDetails.accountHolderName) ||
          "",
        bankName:
          (this.invoiceData.transferDetails &&
            this.invoiceData.transferDetails.bankName) ||
          "",
        IFSCcode:
          (this.invoiceData.transferDetails &&
            this.invoiceData.transferDetails.IFSCcode) ||
          "",
        remark:
          (this.invoiceData.transferDetails &&
            this.invoiceData.transferDetails.remark) ||
          ""
      }
    };
  },
  computed: {
    ...mapGlobalGetters(["selectedBrand","finYear","brandFinYear"]),
    ...mapBuyerGetters(["selectedBuyer"]),
    ...mapGlobalGetters({
      gState: 'state',
    }),
    getHeaders(){
       if(this.gstInvoice) {
          return [
          { text: "Name", sortable: false, value: "productName" , class: "font-weight-bold primary--text" },
          { text: "Rate", sortable: false, value: "rate", class: "font-weight-bold primary--text" },
          { text: "Unit", sortable: false, value: "unit", class: "font-weight-bold primary--text" },
          { text: "Quantity", sortable: false, value: "quantity", class: "font-weight-bold primary--text" },
          { text: "Basic Price", sortable: false, value: "basicPrice", class: "font-weight-bold primary--text" },
          { text: "GST value", sortable: false, value: "GSTValue", class: "font-weight-bold primary--text" },
          { text: "Trade Discount", sortable: false, value: "totlePrice", class: "font-weight-bold primary--text" },
          { text: "Total Price", sortable: false, value: "totlePrice", class: "font-weight-bold primary--text", },
          { text: "CGST ", sortable: false, value: "CGST", class: "font-weight-bold primary--text" },
          { text: "SGST ", sortable: false, value: "SGST", class: "font-weight-bold primary--text" },
          { text: "IGST ", sortable: false, value: "IGST", class: "font-weight-bold primary--text" },
          { text: "Action ", sortable: false, value: "action", class: "font-weight-bold primary--text" },
          { text: "", value: "name", sortable: false }
        ]
      }
      else {
        return [
          { text: "Name", sortable: false, value: "productName" , class: "font-weight-bold primary--text" },
          { text: "Rate", sortable: false, value: "rate", class: "font-weight-bold primary--text" },
          { text: "Unit", sortable: false, value: "unit", class: "font-weight-bold primary--text" },
          { text: "Quantity", sortable: false, value: "quantity", class: "font-weight-bold primary--text" },
          { text: "Basic Price", sortable: false, value: "basicPrice", class: "font-weight-bold primary--text" },
          { text: "Trade Discount", sortable: false, value: "totlePrice", class: "font-weight-bold primary--text" },
          { text: "Total Price", sortable: false, value: "totlePrice", class: "font-weight-bold primary--text", },
          { text: "Action ", sortable: false, value: "action", class: "font-weight-bold primary--text" },
          { text: "", value: "name", sortable: false }
        ]
      }
    },
    firmsByBrand() {
      return this.firms
        .filter(item => item["brand"] === this.selectedBrand)
        .map(item => {
          return {
            text: item["name"],
            value: item[".key"]
          };
        });
    },
    
    staffByBrand() {
      return this.staffs
        .filter(item => {
          return (
            item["brand"] === this.selectedBrand && 
            item["firm"] === this.selectedFirm
          );
        })
        .map(item => {
          return {
            text: item["staffName"],
            value: item[".key"]
          };
        });
    },
    // godawnByBrand() {
    //   return this.godawns
    //     .filter(item => {
    //       return (
    //         item["brand"] === this.selectedBrand 
    //       );
    //     })
    //     .map(item => {
    //       return {
    //         text: item["godawnName"],
    //         value: item[".key"]
    //       };
    //     });
    // },
    banksByFirms() {
      return this.banks
        .filter(item => {
          return (
            item["brand"] === this.selectedBrand &&
            item["firm"] === this.selectedFirm
          );
        })
        .map(item => {
          return {
            text: item["bankName"],
            value: item[".key"]
          };
        });
    },
    totalItems() {
      return this.items.length || 0;
    },
    todaysDate() {
      let date = new Date();
      return `${date.getDate()}\\${date.getMonth()}\\${date.getYear()}`;
    },
    principalValueTotal() {
      let total = this.items.reduce(
        (accumulator, currentValue) =>
          accumulator + Number.parseFloat(currentValue.totlePrice),
        0
      );
      // console.log(total)
      let newtotal = Math.round(Number.parseFloat(total));
      //  console.log(newtotal)
      this.roundOffAmount = Number.parseFloat(newtotal - total).toFixed(this.roundOff);
      return newtotal;
    }
  },
  mounted() {
    this.getCurrentUser();
  },
  updated(){
    this.expansionVal = true;
  },
  created() {
    this.invoiceDraft = {
      items: this.items,
      amountFromCash: this.amountFromCash || 0,
      amountFromBank: this.amountFromBank || 0,
      buyerId: this.buyerId,
      brand: this.selectedBrand,
      date: Date.now(),
      transferDetails: this.transferDetails,
      transferType: ["Cash", ""].includes(this.paymentType)
        ? "0"
        : this.transferType,
      duration: this.alertDuration, // days
      paymentType: this.paymentType,
      transactionType: this.transactionType,
      isCredited: false,
      firm: this.selectedFirm,
      bank: ["Cash", ""].includes(this.paymentType) ? "0" : this.selectedBank,
      totalAmount: this.principalValueTotal || 0,
      paidAmount: this.paidAmount || 0,
      remainingAmount: this.remainingAmount || 0,
      labourAmount: this.labourAmount || 0,
      discountAmount: this.discountAmount || 0,
      roundOffAmount : this.roundOffAmount || 0,
      status: this.status,
      gstType: this.gstType,
      invoiceId: this.invoiceId,
      soldBy : this.soldBy,
      brokerageRate : this.brokerageRate,
      // godawnBy : this.godawnBy,
      placeOfSupply : this.placeOfSupply,
      totalTradeDiscount : this.totalTradeDiscount,
      remark : this.remark
    };
    this.$bindAsArray("firms", this.$root.$firebaseRefs.firm.orderByChild('brand').equalTo(this.selectedBrand)),
    this.$bindAsArray("staffs", this.$root.$firebaseRefs.staff.orderByChild('brand').equalTo(this.selectedBrand)),
    // this.$bindAsArray("godawns", this.$root.$firebaseRefs.godawn),
    this.$bindAsArray("banks", this.$root.$firebaseRefs.account.orderByChild('brand').equalTo(this.selectedBrand)),
    this.$bindAsArray("buyers", this.$root.$firebaseRefs.buyer.orderByChild('brand').equalTo(this.selectedBrand)),
    this.$bindAsArray("sellers", this.$root.$firebaseRefs.seller.orderByChild('brand').equalTo(this.selectedBrand));
    // this.$bindAsObject("firmById", this.$root.$firebaseRefs.firm.orderByChild('brand').equalTo(this.selectedBrand));
    // this.$bindAsObject("bankById", this.$root.$firebaseRefs.account.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("termsAndConditions", this.$root.$firebaseRefs.termsAndConditions.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("invoicesOfFirm", this.$root.$firebaseRefs.invoice.orderByChild('brand').equalTo(this.selectedBrand));

    // this.$bindAsArray("brand", this.$root.$firebaseRefs.invoice.orderByChild('brand').equalTo(this.brand));
  },
  watch: {
    invoiceData: {
      handler(newVal, oldVal) {
        this.items = newVal.items || [];
        this.totalTradeDiscount = newVal.totalTradeDiscount || 0;
        this.alertDuration = newVal.duration || 0;
        this.paymentType = newVal.paymentType || "";
        (this.transferType = ["Cash", ""].includes(this.invoiceData.paymentType)
          ? "0"
          : this.invoiceData.transferType),
          (this.amountFromCash = newVal.amountFromCash || 0),
          (this.amountFromBank = newVal.amountFromBank || 0),
          (this.transactionType = newVal.transactionType || ""),
          (this.rate = newVal.rate || 2);
        this.invoiceDate = newVal.date
          ? new Date(newVal.date).toISOString().substr(0, 10)
          : new Date().toISOString().substr(0, 10);
        this.selectedFirm = newVal.firm || this.selectedFirm || 0;
        this.soldBy = newVal.soldBy || 0;
       // this.brokerageRate = newVal.brokerageRate || 0,
        this.godawnBy = newVal.godawnBy || 0;
        this.placeOfSupply = newVal.placeOfSupply || 0;
        this.selectedBank = newVal.bank || 0;
        (this.totalAmount = newVal.totalAmount || 0),
          (this.paidAmount = newVal.paidAmount || 0),
          (this.remainingAmount = newVal.remainingAmount || 0),
          (this.labourAmount = newVal.labourAmount || 0),
          (this.discountAmount = newVal.discountAmount || 0);
        (this.status = newVal.status || ""),
          (this.gstType = newVal.gstType || "")
          this.remark = newVal.remark
          //this.invoiceId = newVal.invoiceId || this.invoiceId || "";
      },
      deep: true
    },
    items: {
      handler(newVal, oldVal) {
        this.updateAndEmit("totalAmount", this.principalValueTotal);
        // this.updateAndEmit('totalCurrentAmount', this.currentValueTotal)
      },
      deep: true
    },
    mode() {
        this.calculateGSTType();
        this.calculateTotal();
    },
    selectedBrand(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.updateAndEmit("brand", newVal);
      }
    },
    status(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.updateAndEmit("status", newVal);
      }
    },
    transferDetails: {
      handler(newVal, oldVal) {
        this.invoiceDraft.transferDetails.accountNumber = newVal.accountNumber;
        this.invoiceDraft.transferDetails.accountHolderName =
          newVal.accountHolderName;
        this.invoiceDraft.transferDetails.bankName = newVal.bankName;
        this.invoiceDraft.transferDetails.IFSCcode = newVal.IFSCcode;
        this.invoiceDraft.transferDetails.remark = newVal.remark;
      },
      deep: true
    },
    gstType(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.updateAndEmit("gstType", newVal);
      }
    },
    placeOfSupply(newVal, oldVal) {
      if (oldVal !== newVal) {
         console.log(newVal)
        this.updateAndEmit("placeOfSupply", newVal);
        this.calculateGSTType();
      }
    },
    soldBy(newVal, oldVal) {
      if (oldVal !== newVal) {
        console.log(newVal)
        this.calculateBrokerage();
        this.updateAndEmit("soldBy", newVal);
      }
    },
    remark(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.updateAndEmit("remark", newVal);
      }
    },
    brokerageRate(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.updateAndEmit("brokerageRate", newVal);
      }
    },
    // godawnBy(newVal, oldVal) {
    //   if (oldVal !== newVal) {
    //     this.updateAndEmit("godawnBy", newVal);
    //   }
    // },
    transferType(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.updateAndEmit("transferType", newVal);
      }
    },
    buyerId(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.updateAndEmit("buyerId", newVal);
      }
    },
    alertDuration(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.updateAndEmit("duration", Number.parseInt(newVal));
      }
    },
    paymentType(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.updateAndEmit("paymentType", newVal);
        if (this.selectedFirm != "") this.getFirmAndBankBalance();
        this.calculateTotal();
      }
    },
    transactionType(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.updateAndEmit("transactionType", newVal);
        switch (newVal) {
          case "Debit": {
            this.updateAndEmit("status", "due");
            break;
          }
          case "Partial Paid": {
            this.updateAndEmit("status", "partial");
            if (!this.transactionDialog) this.transactionDialog = true;
            break;
          }
          case "Credit": {
            this.updateAndEmit("status", "paid");
            if (!this.transactionDialog) this.transactionDialog = true;
            break;
          }
        }
        this.calculateTotal();
      }
    },
    invoiceDate(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.updateAndEmit("date", new Date(newVal).getTime());
      }
    },
    invoiceId(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.updateAndEmit("invoiceId", newVal);
      }
    },
    selectedFirm(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.updateAndEmit("firm", newVal);
        this.getFirmAndBankBalance();
        this.calculateGSTType();
        this.firmBasedInvoiceId();
      }
    },
    selectedBank(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.updateAndEmit("bank", newVal);
        if (this.selectedFirm != "") this.getFirmAndBankBalance();
      }
    },
    amountFromCash(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.calculateTotal('amountFromCash');
      }
    },
    amountFromBank(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.calculateTotal('amountFromBank');
      }
    },
    discountAmount(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.updateAndEmit("discountAmount", newVal);
        this.calculateTotal();
      }
    },
    labourAmount(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.updateAndEmit("labourAmount", newVal);
        this.calculateTotal();
      }
    },
    roundOffAmount(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.updateAndEmit("roundOffAmount", newVal);
        //this.calculateTotal();
      }
    }
  },
  methods: {
    firmById(id){
      return this.firms.filter(item => item['.key'] == id)[0];
    },
    buyerById(id){
      return this.buyers.filter(item => item['.key'] == id)[0];
    },
    sellerById(id){
      return this.sellers.filter(item => item['.key'] == id)[0];
    },
    bankById(id){
      return this.banks.filter(item => item['.key'] == id)[0];
    },
    calculateBrokerage(){
        let staffObj = this.staffs
        .filter(item => {
          return (
            item[".key"] === this.soldBy
          );
        })[0];
        if(staffObj) {
          this.brokerageRate = Number.parseFloat(staffObj.brokerageRate);
          console.log(this.brokerageRate)
        }
    },
    formatDate(){
      var tomorrow = new Date(this.dateFormatted);
      tomorrow.setDate(tomorrow.getDate() + 1);
      this.invoiceDate =  new Date(tomorrow).toISOString().substr(0, 10)
    },
    async basicInvoicePrint(){
      let termsAndConditions = this.getTermsAndConditions();
      this.calculateGSTType();
        let firm = this.firmById(this.selectedFirm);
        firm.address = this.getAddress(firm);
        let customer = this.currentUser;
        customer.address = this.getAddress(customer);
        if(this.gstInvoice) {
          await convertToBasicInvoice({
              invoiceData:this.invoiceDraft,
              firm:firm,
              customer : customer,
              gstTotal : this.GST_Val_total,
              terms : termsAndConditions[0]
            }).then((doc)=>{
               pdfMake.createPdf(doc).download();
            })
        } else {
          await convertToBasicInvoiceWithoutGST({
                invoiceData:this.invoiceDraft,
                firm:firm,
                customer : customer,
                gstTotal : this.GST_Val_total,
                terms : termsAndConditions[0]
              }).then((doc)=>{
               pdfMake.createPdf(doc).download();
            })
        }
    },
    basicInvoicePrint1(){
      let termsAndConditions = this.getTermsAndConditions();
      // if(termsAndConditions.length) {
      //   let banks = [];
      //   termsAndConditions[0].bank.map((bankId) =>{
      //     let bank = this.bankById[bankId]
      //     bank.address = this.getAddress(bank);
      //     banks.push(bank);
      //   })
      //   termsAndConditions[0].bank = banks;
      // } else {
      //   termsAndConditions = [{
      //     termsAndConditions : "",
      //     bank : []
      //   }]
      // }
      this.calculateGSTType();
        let firm = this.firmById(this.selectedFirm);
        firm.address = this.getAddress(firm);
        let customer = this.currentUser;
        customer.address = this.getAddress(customer);

          let doc = this.gstInvoice ? convertToBasicInvoice({
              invoiceData:this.invoiceDraft,
              firm:firm,
              customer : customer,
              gstTotal : this.GST_Val_total,
              terms : termsAndConditions[0]
            }) : convertToBasicInvoiceWithoutGST({
              invoiceData:this.invoiceDraft,
              firm:firm,
              customer : customer,
              gstTotal : this.GST_Val_total,
              terms : termsAndConditions[0]
         });
         
      pdfMake.createPdf(doc).download();
    },
    getTermsAndConditions(){
      let termsAndConditions = this.termsAndConditions.filter(item => item["brand"] === this.selectedBrand && 
       (item['firm'] === this.selectedFirm));
      // console.log(termsAndConditions)
      if(termsAndConditions.length) {
        if(termsAndConditions[0].bank) {
        let banks = [];
        termsAndConditions[0].bank.map((bankId) =>{
          let bank = this.bankById(bankId)
          bank.address = this.getAddress(bank);
          banks.push(bank);
        })
        termsAndConditions[0].banks = banks;
      } else {
          termsAndConditions[0].banks = [];
        }
      } else {
        termsAndConditions = [{
          termsAndConditions : "",
          banks: []
        }]
      }
      return termsAndConditions;
    },
    getAddress(item) {
      if(!item) {
        return '';
      }
      let address =
        (item.village ? item.village + " - " : "") +
        (item.block ? item.block + " - " : "") +
        (item.tehsil ? item.tehsil + " - " : "") +
        (item.district ? item.district + " - " : "") +
        (item.state ? item.state + " - " : "") +
        (item.country ? item.country + " - " : "");
      address = address.substring(0, address.length - 2);
      return address;
    },
    print() {
      // let doc = convertToPDFObject(this.items,{
      //   transferType : this.transferType,
      //   amountFromCash : this.amountFromCash,
      //   amountFromBank : this.amountFromBank,
      //   paymentType : this.paymentType,
      //   alertDuration : this.alertDuration,
      //   totalAmount : this.principalValueTotal,
      //   paidAmount : this.paidAmount,
      //   remainingAmount : this.remainingAmount,
      //   discountAmount : this.discountAmount,
      //   labourAmount : this.labourAmount,

      // });
      this.printDialog = true;
      //pdfMake.createPdf(doc).download();
    },
    resetAmounts() {
      this.amountFromCash = 0;
      this.amountFromBank = 0;
      this.discountAmount = 0;
      this.labourAmount = 0;
    },
    getFirmAndBankBalance() {
      let selectedFirm = this.firms.filter(
              item =>
                item["brand"] === this.selectedBrand &&
                item[".key"] == this.selectedFirm
            );
       this.gstInvoice = selectedFirm[0].GST_user && selectedFirm[0].GST_user == 'Yes'?  true : false; 
      let selectedBank = this.selectedBank ? this.banks.filter(
        item =>
          item["brand"] === this.selectedBrand &&
          item[".key"] == this.selectedBank
      ) : null;
      switch (this.paymentType) {
         
        case "Cash": {
          if (this.selectedFirm) {
           
            this.availableBalance =
              selectedFirm.length &&
              (selectedFirm[0]["amount"] ? selectedFirm[0]["amount"] : 0);
          } else {
            this.availableBalance = 0;
          }
          break;
        }
        case "Bank Account": {
          if (this.selectedBank) {
           
            this.availableBalance =
              selectedBank.length &&
              (selectedBank[0]["amount"] ? selectedBank[0]["amount"] : 0);
          } else {
            this.availableBalance = 0;
          }
          break;
        }
        case "CashAndBank Account": {
          if (this.selectedFirm && this.selectedBank) {
            this.availableBalance =
              selectedFirm.length &&
              selectedBank.length &&
              (selectedBank[0]["amount"] ? selectedBank[0]["amount"] : 0) +
                (selectedFirm[0]["amount"] ? selectedFirm[0]["amount"] : 0);
          } else {
            this.availableBalance = 0;
          }
          break;
        }
      }
    },
    editItem(item,fromDialog) {
      this.editedIndex = this.items.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.isEditItems = true;
      if(!fromDialog) {
        this.dialog = true;
      }
    },
    deleteItem(item) {
      const index = this.items.indexOf(item);
      confirm("Are you sure you want to delete this item?") &&
        this.items.splice(index, 1);
    },
    close(saveAddItem) {
      if(!saveAddItem) {
         this.dialog = false;
      } 
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },
    calculateTotal(type) {
      let discountAmount = Number.parseFloat(this.discountAmount);
      let labourAmount = Number.parseFloat(this.labourAmount);
      let amountFromBank = Number.parseFloat(this.amountFromBank);
      let amountFromCash = Number.parseFloat(this.amountFromCash);
      let totalAmount = Number.parseFloat(this.totalAmount);
      switch(this.paymentType) {
        case 'Cash': {
          this.amountFromBank = 0;
          this.amountFromBankDisabled = true;
          switch(this.transactionType) {
            case 'Debit': {
              this.amountFromCashDisabled = true;
              this.amountFromCash = (totalAmount + labourAmount) - discountAmount;
              this.remainingAmount = (totalAmount + labourAmount) - discountAmount;
              this.paidAmount = 0;
              break;
            }
            case 'Partial Paid': {
              this.amountFromCashDisabled = false;
              this.remainingAmount = (totalAmount + labourAmount) - (amountFromCash + discountAmount);
              this.paidAmount = amountFromCash
              break;
            }
            case 'Credit': {
              this.amountFromCashDisabled = true;
              this.amountFromCash = (totalAmount + labourAmount) - discountAmount;
              this.remainingAmount = 0;
              this.paidAmount = (totalAmount + labourAmount) - discountAmount;
              break;
            }
          }
          break;
        }
        case 'Bank Account': {
          this.amountFromCashDisabled = true;
          this.amountFromCash = 0;
          switch(this.transactionType) {
            case 'Debit': {
              this.amountFromBankDisabled = true;
              this.amountFromBank = (totalAmount + labourAmount) - discountAmount;
              this.remainingAmount = (totalAmount + labourAmount) - discountAmount;
              this.paidAmount = 0;
              break;
            }
            case 'Partial Paid': {
              this.amountFromBankDisabled = false;
              this.remainingAmount = (totalAmount + labourAmount) - (amountFromBank + discountAmount);
              this.paidAmount = amountFromBank;
              break;
            }
            case 'Credit': {
              this.amountFromBankDisabled = true;
              this.amountFromBank = (totalAmount + labourAmount) - discountAmount;
              this.remainingAmount = 0;
              this.paidAmount = (totalAmount + labourAmount) - discountAmount;
              break;
            }
          }
          break;
        }
        case 'CashAndBank Account': {
          this.amountFromCashDisabled = false;
          this.amountFromBankDisabled = false;
          let totalBankAndCash =  amountFromCash + amountFromBank
          switch(this.transactionType) {
            case 'Debit': {
              this.remainingAmount = (totalAmount + labourAmount) - discountAmount;
              this.paidAmount = 0;
              break;
            }
            case 'Partial Paid': {
              this.paidAmount = totalBankAndCash;
              this.remainingAmount = (totalAmount + labourAmount) - (paidAmount + discountAmount);
              break;
            }
            case 'Credit': {
              this.remainingAmount = 0;
              this.paidAmount = (totalAmount + labourAmount) - discountAmount;
              break;
            }
          }
          break;
        }
        case '': {
          this.amountFromCashDisabled = true;
          this.amountFromBankDisabled = true;
          this.amountFromCash = 0;
          this.amountFromBank = 0;
          this.paidAmount = 0;
          this.remainingAmount = (totalAmount + labourAmount) - discountAmount;
          break;
        }
      }
      this.paidAmount = Number.parseFloat(this.paidAmount).toFixed(parseInt(this.roundOff));
      if(type!='amountFromCash')
      this.amountFromCash = Number.parseFloat(this.amountFromCash).toFixed(parseInt(this.roundOff));
      if(type!='amountFromBank')
      this.amountFromBank = Number.parseFloat(this.amountFromBank).toFixed(parseInt(this.roundOff));
      this.remainingAmount = Number.parseFloat(this.remainingAmount).toFixed(parseInt(this.roundOff));
      this.updateAndEmit('paidAmount', this.paidAmount)
      this.updateAndEmit('amountFromCash', this.amountFromCash)
      this.updateAndEmit('amountFromBank', this.amountFromBank)
      this.updateAndEmit('remainingAmount', this.remainingAmount)
    },
    save(editedItem,saveAndAdd) {
      if (this.editedIndex > -1) {
        Object.assign(this.items[this.editedIndex], editedItem);
      } else {
        this.items.push(editedItem);
      }
      this.calculateGSTType();
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
        this.isEditItems = false;
      }, 300);
      this.close(saveAndAdd);
    },
    calculateGSTType() {
      if (Object.keys(this.currentUser).length === 0) {
        this.getCurrentUser();
      }
      this.GST_Val_total.SGST_val = 0;
      this.GST_Val_total.CGST_val = 0;
      this.GST_Val_total.IGST_val = 0;
      this.items.map((item, index) => {
        let GST = item["taxableGST_rate"];
        let firm = this.firmById(this.selectedFirm);
        if (
          this.selectedFirm &&
          this.currentUser.state &&
          Number.parseFloat(GST) &&
          firm.state === this.placeOfSupply
        ) {
          item["CGST_val"] = item["GSTValue"] / 2;
          item["CGST"] = GST / 2;
          item["SGST_val"] = item["GSTValue"] / 2;
          item["SGST"] = GST / 2;
          item["IGST"] = 0;
          item["IGST_val"] = 0;
          this.GST_Val_total.SGST_val += Number.parseFloat(item["SGST_val"]);
          this.GST_Val_total.CGST_val += Number.parseFloat(item["CGST_val"]);
          this.GST_Val_total.IGST_val += Number.parseFloat(item["IGST_val"]);
          this.updateAndEmit("gstType", "SGST|CGST");
        } else {
          item["IGST"] = GST;
          item["CGST"] = 0;
          item["SGST"] = 0;
          item["IGST_val"] = item["GSTValue"];
          item["CGST_val"] = 0;
          item["SGST_val"] = 0;
          this.GST_Val_total.SGST_val += Number.parseFloat(item["SGST_val"]);
          this.GST_Val_total.CGST_val += Number.parseFloat(item["CGST_val"]);
          this.GST_Val_total.IGST_val += Number.parseFloat(item["IGST_val"]);
          this.updateAndEmit("gstType", "IGST");
          this.totalTradeDiscount += Number.parseFloat(item["tradeDiscount"]);
        }
        this.items[index] = item;
      });
      this.GST_Percentage_total = getGSTPercentageTotal(this.items);
      this.updateAndEmit("items", this.items);
      this.updateAndEmit("tradeDiscount", this.totalTradeDiscount);
    },
    updateAndEmit(key, value) {
      this.invoiceDraft[key] = value;
      this.$emit("setInvoiceData", this.invoiceDraft);
    },
    saveAndPrint(){
      this.basicInvoicePrint();
      this.saveInvoice();
    },
    saveInvoice() {
      this.updateAndEmit("buyerId", this.selectedBuyer);
      this.$emit("close");
    },
    getCurrentUser() {
      let buyer = this.buyerById(this.selectedBuyer);
      let seller = this.sellerById(this.selectedBuyer);
      this.isUserBuyer =  buyer  ? true : false ;
      // this.currentUser =
      //   buyer && buyer.state ? buyer : seller && seller.state ? seller : {};
      // this.placeOfSupply = this.currentUser.state;
      this.currentUser = buyer  ? buyer : seller;
      if(this.currentUser.state) {
        this.placeOfSupply = this.currentUser.state;
      }
      if(this.currentUser.defaultFirm) {
        // console.log(this.currentUser.defaultFirm)
        this.selectedFirm = this.currentUser.defaultFirm; 
      } 
      else {
        let defaultFirm = this.firms.filter(item => (item["brand"] === this.selectedBrand && !!item['defaultFirm']))[0];
        this.selectedFirm = defaultFirm['.key']
        // this.selectedFirm = this.firmsByBrand[0].value;
        // console.log(this.selectedFirm)
      }
       this.getFirmAndBankBalance();
      if(!this.invoiceId) {
         this.firmBasedInvoiceId();
      }
    },
    firmBasedInvoiceId(){
      if(this.isUserBuyer) {
        let firmInvoiceCount = this.invoicesOfFirm.filter(
         item =>
                item["brand"] === this.selectedBrand &&
                item["firm"] == this.selectedFirm && 
                item["isBuyer"] == true
            ).length;
        let finYear = (new Date().getFullYear()) + '-' + ((new Date().getFullYear() + 1) % 100) + '-SF-';
        this.invoiceId = finYear + (firmInvoiceCount + 1);
        console.log(this.invoiceId)
      }
    },
    duplicateCheckInvoiceId(){
      let invoices = this.invoicesOfFirm.filter(
              item =>
                item["brand"] === this.selectedBrand &&
                item["firm"] == this.selectedFirm && 
                item["invoiceId"] == this.invoiceId
            );

      if(invoices.length) {
         this.duplicateError = 'Invoice with invoiceId ' + this.invoiceId + ' Already exist.';
                setTimeout(() => {
                    this.duplicateError = null;
          }, 3000);
      }
    }
  }
};
</script>

<style>
.invoiceExpansion .v-expansion-panel__header {
  background-color: #15155d;
}

.invoiceExpansion .v-icon {
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/Buyers/Invoice/InvoiceScreen.vue